import { render } from "./gsrbr0106.vue?vue&type=template&id=539d7cac&scoped=true"
import script from "./gsrbr0106.vue?vue&type=script&lang=js"
export * from "./gsrbr0106.vue?vue&type=script&lang=js"

import "./gsrbr0106.vue?vue&type=style&index=0&id=539d7cac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539d7cac"]])

export default __exports__